import React from 'react'
import DropdownSelect from '../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { DropdownOptionSelection, FieldProps } from '../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../@types/validation-types'
import { HeatingTypeOption } from '../../../../../../@types/dropdown-types'
import { getDefaultClasses } from '../../../../../../utils/style-utils'

const HeatingTypeField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = getDefaultClasses('left'),
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        label='heatingType.label'
        id='construction-heating-type'
        name='constructionHeatingType'
        value={insertionData.constructionHeatingType}
        noInformation={HeatingTypeOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'heatingType.options',
          options: Object.keys(HeatingTypeOption),
        }}
        onChange={(value: DropdownOptionSelection) =>
          onChange({ screen: screenName, property: 'constructionHeatingType' }, value.value!)
        }
      />
    </div>
  )
}

export default HeatingTypeField
